import {combineReducers} from 'redux';

function open(state = false, action) {
  switch (action.type) {
    case 'SET_OPEN_TOOGLE_STATE':
      return action.open;
    default:
      return state;
  }
}

function active(state = false, action) {
  switch (action.type) {
    case 'SET_ACTIVE_TOOGLE_STATE':
      return action.active;
    default:
      return state;
  }
}

function startDate(state = new Date().getTime(), action) {
  switch (action.type) {
    case 'SET_START_DATE_STATE':
      return action.startDate;
    default:
      return state;
  }
}

function endDate(state = new Date().getTime(), action) {
  switch (action.type) {
    case 'SET_END_DATE_STATE':
      return action.endDate;
    default:
      return state;
  }
}

function dateRange(state = [], action) {
  switch (action.type) {
    case 'SET_DATES_RANGE_STATE':
      return action.dateRange;
    default:
      return state;
  }
}

export default combineReducers({
  open,
  active,
  startDate,
  endDate,
  dateRange
});



// WEBPACK FOOTER //
// ./reducers/datepicker.js